import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';

export function extractIsoAndNational(
  phone: string,
  fallback: TuiCountryIsoCode = TuiCountryIsoCode.ES 
): { iso: TuiCountryIsoCode; national: string } {
  const parsed = parsePhoneNumberFromString(phone);
  if (!parsed) {
    return { iso: fallback, national: phone };
  }
  return {
    iso: parsed.country as TuiCountryIsoCode,
    national: parsed.formatNational(),
  };
}

/** Elimina la extensión y devuelve ISO + número nacional */
export function splitPhone(phoneRaw: string): {
  iso: TuiCountryIsoCode;
  national: string;          // “722 000 000”
  fullWithoutExt: string;    // “+34 722 000 000”
} {
  if (!phoneRaw) {
    return {
      iso: TuiCountryIsoCode.ES,
      national: '',
      fullWithoutExt: '',
    };
  }

  // 1) Quitamos la extensión (“x123”, “ext. 456”, “#89”…)
  const cleaned = phoneRaw
    .replace(/\s*(ext\.?|x|#)\s*\d+$/i, '')   // ext al final
    .replace(/[^\d+]/g, '');                  // guiones, espacios…

  // 2) Intentamos parsear
  const parsed = parsePhoneNumberFromString(cleaned);

  if (parsed) {
    return {
      iso: parsed.country as TuiCountryIsoCode,
      national: parsed.formatNational(),      // «722 000 000»
      fullWithoutExt: parsed.formatInternational(), // «+34 722 000 000»
    };
  }

  // Si no es parseable, devolvemos tal cual
  return {
    iso: TuiCountryIsoCode.ES,
    national: cleaned,
    fullWithoutExt: cleaned,
  };
}

export const phoneExamples: Partial<Record<TuiCountryIsoCode, string>> = {
  [TuiCountryIsoCode.ES]: '+34 612 345 678',
  [TuiCountryIsoCode.GB]: '+44 7123 456 789',
  [TuiCountryIsoCode.FR]: '+33 6 12 34 56 78',
  [TuiCountryIsoCode.DE]: '+49 1512 345 6789',
  [TuiCountryIsoCode.IT]: '+39 312 345 6789',
  [TuiCountryIsoCode.PT]: '+351 912 345 678',
  [TuiCountryIsoCode.NL]: '+31 6 1234 5678',
  [TuiCountryIsoCode.AD]: '+376 612 345',
  [TuiCountryIsoCode.CL]: '+56 9 6123 4567',
  [TuiCountryIsoCode.DO]: '+1 809 234 5678',
};

export function getCountryIsoFromPhone(phone: string): TuiCountryIsoCode {
    if (phone.startsWith('+34'))  return TuiCountryIsoCode.ES;
    if (phone.startsWith('+44'))  return TuiCountryIsoCode.GB;
    if (phone.startsWith('+33'))  return TuiCountryIsoCode.FR;
    if (phone.startsWith('+39'))  return TuiCountryIsoCode.IT;
    if (phone.startsWith('+49'))  return TuiCountryIsoCode.DE;
    if (phone.startsWith('+351')) return TuiCountryIsoCode.PT;
    if (phone.startsWith('+31'))  return TuiCountryIsoCode.NL;
    if (phone.startsWith('+376')) return TuiCountryIsoCode.AD;
    if (phone.startsWith('+56'))  return TuiCountryIsoCode.CL;
    if (phone.startsWith('+1'))   return TuiCountryIsoCode.DO;
    return TuiCountryIsoCode.ES;
  }
